import {Type} from "class-transformer";

import {serializeType} from "./common";
import {PartnerInvoiceChargeCode, PurchaseChargeCode, UniqueChargeCode} from "./charge-code";
import {AbstractItem} from "./item";
import {ReceiptItem} from "./receipt";
import {ItemType} from "@app/shared/enums/item-type.enum";
import {FundingType} from "@app/shared/enums/funding-type.enum";

export class PurchaseRequisitionItem {
  id: number;
  version: number;

  revision: number;
  subtype: ItemType;
  fundingType: FundingType;

  //purchaseTxnDescription: string;
  commodityDescription: string;

  itemCatalogId: number;
  itemCatalogName: string;

  @Type(serializeType(AbstractItem)) children: AbstractItem[];

  abstractItemId: number;
  nameOrNumber: string;
  description: string;
  unitOfMeasureId: number;
  unitOfMeasureDescription: string;

  itemNotes: string;                    // note on item stored in the catalog; readonly for line item add
  lineNotes: string;                    // note about the item to be shown on PO; processed by PR
  internalNotes: string;                // internal note for approval and other internal use, processed by PR, Invoice and Receipt; Return has its own returnReasons

  addtoCatalog: boolean;
  addtoFavorite: boolean;

  commodityCodeId: number;
  commodityCodeDescription: string;

  qtyOrdered?: number;                  // for Purchase Req, Sales Order, Material Order, BOM
  qtyDelivered?: number;                // for Customer Invoice and Packing Slip
  qtyReceived?: number;                 // for Receipt and Vendor Invoice
  qtyBackOrdered?: number;              // for Receipt, Vendor Invoice, Packing Slip, Customer Invoice

  quantityOnHand?: number;              // Material Order specific attributes
  manufacturerNumber?: string;          // Material Order specific attribute

  unitCost?: number;                    // item cost in the catalog for PR, PO
  actualUnitCost?: number;              // adjusted item cost for Vendor Invoice
  salesPrice?: number;                  // item sales price in the catalog for Sales Order and Customer Invoice
  actualUnitPrice?: number;             // adjusted item sales price for Sales Order and Customer Invoice
  extendedPrice: number;                // for all
  taxAmount: number;                    // for all
  isTaxable: boolean;                   // if true, compute and return tax using the input tax rate

  taskId?: number;                      // for Sales Order and Customer Invoice
  taskName?: string;                    // for Sales Order and Customer Invoice

  vendorLaborCategoryId?: number;       // vendor labor category
  effectiveFrom?: string;               // vendor labor category effective from
  effectiveThru?: string;               // vendor labor category effective through
  projectName?: string;                         // vendor labor category associated project
  projectLaborCategoryPositionTitle?: string;   // project labor category associated with the vendor labor category

  @Type(serializeType(ReceiptItem)) itemReceipt?: ReceiptItem;
  @Type(serializeType(PurchaseChargeCode)) purchaseChargeCodes: Array<PurchaseChargeCode>;
  @Type(serializeType(UniqueChargeCode)) uniqueChargeCodes?: Array<UniqueChargeCode>;                           //trading partner using it
  @Type(serializeType(PartnerInvoiceChargeCode)) partnerInvoiceChargeCodes?: Array<PartnerInvoiceChargeCode>;   //partner invoice using it

  constructor() {
    this.purchaseChargeCodes = new Array<PurchaseChargeCode>();
  }
}

export class Bom {
  id: number;
  version: number;
  itemQty: number;
  extendedPrice: number;
  bomItemId: number;
  parentId: number;
  itemId: number;
  @Type(serializeType(AbstractItem)) abstractItemDetail: AbstractItem;
  @Type(serializeType(Bom)) children: Bom[];
  @Type(serializeType(Bom)) parent: Bom;
}
